import { useCallback } from "react"
import { useQuery } from "@rocicorp/zero/react"
import { useNavigate } from "@tanstack/react-router"

import { isOutOfOffice } from "@productlane/lib/src/out-of-office"
import { queries } from "@productlane/zero/queries"

import { useOutOfOfficeDialog } from "@/stores/out-of-office-store"

/** Opens the turn-on dialog, or the profile card where it's managed once already away. */
export function useOpenOutOfOffice() {
	const [user] = useQuery(queries.currentUser())
	const setOpen = useOutOfOfficeDialog((state) => state.setOpen)
	const navigate = useNavigate()
	const isAway = isOutOfOffice(user?.memberships?.outOfOfficeUntil)

	return useCallback(() => {
		if (isAway) void navigate({ to: "/settings/profile" })
		else setOpen(true)
	}, [isAway, navigate, setOpen])
}
